export const MessageActions = {
  PAYMENT_METHOD: 'paymentMethod',
  CARD_TYPE_CHANGE: 'cardTypeChange',
  FIELD_VALUE: 'fieldValue',
  GET_VALUE: 'getValue',
  RESIZE_FRAME: 'resizeFrame',
  IFRAME_LOADED: 'iframeLoaded',
  GET_VERSION: 'getVersion',
  VERSION_RECEIVED: 'versionReceived',
  UPDATE_STYLES: 'updateStyles',
  PERMISSIONS: 'permissions',
  ENABLE_FIELDS: 'enableFields',
  APPLE_PAY_TOKEN: 'applePayToken',
  GOOGLE_PAY_TOKEN: 'googlePayToken',
  TUAPAY_OPEN_FRAME: 'tuaPayOpenFrame',
  TUAPAY_BTN_CLICKED: 'tuaPayBtnClicked',
  GOOGLE_PAY_BTN_CLICKED: 'googlePayBtnClicked',
  APPLE_PAY_BTN_CLICKED: 'applePayBtnClicked',
  TUAPAY_GET_LOAN_REQUEST_DETAILS: 'tuaPayGetLoanRequestDetails',
  TUAPAY_LOAN_REQUEST_DETAILS: 'tuaPayLoanRequestDetails',
  TUAPAY_LOAN_RESULT: 'tuaPayLoanResult',
  TUAPAY_SET_LABEL: 'tuaPaySetLabel',
} as const;
